export default __webpack_public_path__ + "static/media/block-white.c765d471.svg";